<ngx-spinner id="spinner" bdOpacity="1" bdColor="#333333" size="large" color="#f00" type="ball-clip-rotate"
  [fullScreen]="true">
  <img id="splash_logo" src="..\assets\img\logo.png" />
</ngx-spinner>

<div class="easytrack-app">
  <!--Check terms-->
  @if (isLoaded() && !isTermsChecked()) {
  <div id="content-check-terms">
    <app-check-terms (isTermsCheckedEvent)="receiveIsTermsChecked($event)" />
  </div>
  }

  @if (isLoaded() && isTermsChecked()) {
  <header>
    <app-header />
  </header>
  <main>
    <router-outlet />
  </main>
  <bs-toasts-container />
  }

</div>